import { ContactInformationFormType } from '@/components/modules/Application/components/ContactInformation/_shared/schemas/contactInformationForm.schema';
import { useApplicationNavigation } from '@/components/modules/Application/hooks/useApplicationNavigation';
import { useApplicationContext } from '@/contexts/ApplicationContext/ApplicationContext';

export const useReferences = () => {
  const { onNext } = useApplicationNavigation();
  const {
    actions: { updateApplicationContext },
  } = useApplicationContext();
  const submitReferences = (formValues: ContactInformationFormType) => {
    updateApplicationContext({
      orderReference1: formValues.orderReference1,
      orderReference2: formValues.orderReference2,
    });
    onNext();
  };

  return { submitReferences };
};
